import { render, staticRenderFns } from "./autoAssign.vue?vue&type=template&id=2acea994&scoped=true&"
import script from "./autoAssign.vue?vue&type=script&lang=js&"
export * from "./autoAssign.vue?vue&type=script&lang=js&"
import style0 from "./autoAssign.vue?vue&type=style&index=0&id=2acea994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acea994",
  null
  
)

export default component.exports